module.exports = __webpack_public_path__ + "static/media/login.9b704b66.jpeg";